import { useMemo } from 'react'
import { VerificationRequestStatus } from 'constants/verification'
import { AccountTypes } from 'types/types'
import { useProfileQuery } from './queries/useProfileQuery'
import { useUserAccountsQuery } from './queries/useUserAccountsQuery'
import { useVerificationRequestStatusQuery } from './queries/useVerificationRequestStatusQuery'

export const useRequestsOnLogin = () => {
  const { data: profile, isFetching: isLoadingProfile } = useProfileQuery()

  const { data: userAccounts, isFetching: isLoadingUserAccounts } = useUserAccountsQuery()

  const { data: verificationRequestStatus, isFetching: isLoadingVerificationRequestStatus } =
    useVerificationRequestStatusQuery()

  const currentAccount = useMemo(
    () => userAccounts?.find(account => account?.isCurrent),
    [userAccounts]
  )

  const isDeveloperAccount: boolean =
    profile?.options?.registrationAccountType === AccountTypes.DEVELOPER

  const isVerifiedBusinessAccount = useMemo(
    () => verificationRequestStatus === VerificationRequestStatus.VERIFIED,
    [verificationRequestStatus]
  )

  const isLoadingRequestsOnLogin = useMemo(
    () => isLoadingProfile || isLoadingUserAccounts || isLoadingVerificationRequestStatus,
    [isLoadingProfile, isLoadingUserAccounts, isLoadingVerificationRequestStatus]
  )

  return {
    profile,
    currentAccount,
    isDeveloperAccount,
    isVerifiedBusinessAccount,
    verificationRequestStatus,
    isLoadingRequestsOnLogin,
    isLoadingProfile,
    isLoadingUserAccounts,
  }
}
